// Should stay in sync with https://git.hubteam.com/HubSpot/PropertiesExtensions/blob/dfa89e7d25306f76b89402adb93157a5e756de97/PropertiesExtensionsModels/src/main/java/com/hubspot/properties/extensions/models/decorators/DecoratorColor.java#L3-L3
export const decoratorColorToTrellisTokenMap = {
  BLACK: 'fill-accent-neutral-default',
  GRAY: 'fill-accent-neutral-subtle-alt',
  GREEN: 'fill-accent-green-default',
  GREEN_LIGHT: 'fill-accent-green-subtle',
  YELLOW: 'fill-caution-default',
  YELLOW_LIGHT: 'fill-accent-yellow-subtle',
  RED: 'fill-accent-red-default',
  RED_LIGHT: 'fill-accent-red-subtle',
  TEAL: 'fill-accent-teal-default',
  TEAL_LIGHT: 'fill-accent-teal-subtle',
  BLUE: 'fill-accent-blue-default',
  BLUE_LIGHT: 'fill-accent-blue-subtle',
  ORANGE: 'fill-accent-orange-default',
  ORANGE_LIGHT: 'fill-accent-orange-subtle',
  PINK: 'fill-accent-magenta-default',
  PINK_LIGHT: 'fill-accent-magenta-subtle',
  PURPLE: 'fill-accent-purple-default',
  PURPLE_LIGHT: 'fill-accent-purple-subtle'
};
export const asDecoratorColor = color => {
  if (color in decoratorColorToTrellisTokenMap) {
    return color;
  }
  return undefined;
};

// Should stay in sync with https://git.hubteam.com/HubSpot/PropertiesExtensions/blob/master/PropertiesExtensionsModels/src/main/java/com/hubspot/properties/extensions/models/decorators/OptionDecoratorStyle.java
export const OptionDecoratorStyles = {
  LABEL_ONLY: 'LABEL_ONLY',
  LABEL_WITH_COLOR: 'LABEL_WITH_COLOR',
  LABEL_WITH_BADGE: 'LABEL_WITH_BADGE'
};
export const {
  LABEL_ONLY,
  LABEL_WITH_COLOR,
  LABEL_WITH_BADGE
} = OptionDecoratorStyles;
export const asOptionDecoratorStyle = value => {
  if (value in OptionDecoratorStyles) {
    return value;
  }
  return undefined;
};